import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

export default () => {//it contains details of job times like start and end time etc.
    let IV2_PageDetails = useContext(RecordsManagementContext).IV2_PageDetails
    return (
        <div className='card'>
            <div className='card-header bg-secondary text-center'>TIME RECORD</div>
            <div className='card-body'>
                {IV2_PageDetails.TimeRecord.JobTimes.map((JobTime, key) => {
                    return (<JobTimeDetails JobTime={JobTime} key={key}/>)
                })}
            </div>
        </div>
    )
}

const JobTimeDetails = (props) => {
    let JobTime = props.JobTime
    return (
        <>
            <div>
                <div className='row small'>
                    <b>{JobTime.HoursType}</b>
                </div>
                <div className='row small'>
                    <div className='col d-flex align-items-center'>
                        <span>Start Time</span>
                        <div className='ml-2'>
                            <input className='w-100' defaultValue={JobTime.Start} disabled/>
                        </div>
                        <span className='ml-2'>Cust. Initial</span>
                        <div className='ml-2'>
                            <img src={JobTime.PictureStart} height='60'/>
                        </div>
                        <span className='ml-2'>{JobTime.PicStartUpdateAt}</span>
                    </div>
                </div>
                <div className='row small mt-1'>
                    <div className='col d-flex align-items-center'>
                        <span>End Time</span>
                        <div className='ml-2'>
                            <input className='w-100' defaultValue={JobTime.End} disabled/>
                        </div>
                        <span className='ml-2'>Cust. Initial</span>
                        <div className='ml-2'>
                            <img src={JobTime.PictureEnd} alt='Customer Sign' height='60'/>
                        </div>
                        <span className='ml-2'>{JobTime.PicEndUpdateAt}</span>
                    </div>
                </div>
                {JobTime.HoursType === "Moving" && (
                    <div className='row small'>
                        <div className='col d-flex align-items-center'>
                       <span className="hourly-rate-label">
                      <span>Hourly</span>
                      <span>Rate:</span>
                       </span>
                            <div className='ml-1'>
                                <input className='w-50' defaultValue={JobTime.HourlyRate} disabled/>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}